require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var userAgent = typeof window !== 'undefined' && window.navigator.userAgent;
exports.isEdge = /(MSIE |Trident\/|Edge\/)/i.test(userAgent);